module.exports = __webpack_public_path__ + "img/appstore_button.db47658b.png";